import type { FC } from 'react';
import { Box, TableCell, Typography } from '@mui/material';

import type { CellProps } from 'src/components/survey/SurveySelectionPage/components/SurveyTableView/types';

import { styles } from './cell.styles';

const ProjectCategoryNameCell: FC<CellProps> = ({ columns, survey }) => (
  <TableCell sx={styles.cell(columns.projectCategoryName.width)}>
    <Box>
      <Typography
        variant="body1"
        sx={styles.pill}
        title={survey.projectCategoryName}
      >
        {survey.projectCategoryName}
      </Typography>
    </Box>
  </TableCell>
);

export default ProjectCategoryNameCell;
